<p-message
  *ngIf="hasCriticalFailure"
  severity="error"
  [text]="criticalFailureMessage"
  styleClass="report-critical-alert"
/>

<div class="report-refresh-bar">
  <span class="report-last-update">
    Última atualização:
    {{
      this.summary.lastUpdated
        ? (this.summary.lastUpdated | date: 'dd/MM/yyyy HH:mm:ss')
        : '—'
    }}
  </span>

  <p-button
    *ngIf="summary.paymentRoundId"
    icon="pi pi-refresh"
    label="Refresh"
    severity="secondary"
    [outlined]="true"
    [loading]="isRefreshing"
    [disabled]="isRefreshing"
    (onClick)="refreshNow()"
  />
</div>

<div *ngIf="isRunning" class="report-running-indicator">
  <p-tag severity="warning" value="Em execução" icon="pi pi-spin pi-spinner" />
  <span class="report-running-hint">
    Os dados são atualizados automaticamente a cada 1 minuto.
  </span>
</div>

<div class="report-summary">
  <section class="report-section">
    <h4>Identificação</h4>
    <div class="report-row">
      <span class="report-label">Round ID</span>
      <span class="report-value">{{ summary.paymentRoundId ?? '—' }}</span>
    </div>
    <div class="report-row">
      <span class="report-label">Agendado para</span>
      <span class="report-value">{{
        (summary.dateScheduled | date: 'dd/MM/yyyy HH:mm') ?? '—'
      }}</span>
    </div>
    <div class="report-row">
      <span class="report-label">Executado em</span>
      <span class="report-value">{{
        (summary.dateExecuted | date: 'dd/MM/yyyy HH:mm') ?? '—'
      }}</span>
    </div>
  </section>

  <section class="report-section">
    <h4>Totais e Aprovação</h4>
    <div class="report-row">
      <span class="report-label">Total de assinantes</span>
      <span class="report-value">{{
        summary.subscriberCount ?? 0 | number
      }}</span>
    </div>
    <div class="report-row">
      <span class="report-label">Total finalizados</span>
      <span class="report-value"
        >{{ summary.finished ?? 0 | number }}
        <ng-container *ngIf="summary.finishedBenefit">
          ({{ summary.finishedBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
    <div class="report-row">
      <span class="report-label">Processados até agora</span>
      <span class="report-value"
        >{{ summary.totalProcessed ?? 0 | number }}
        <ng-container *ngIf="summary.totalProcessedBenefit">
          ({{ summary.totalProcessedBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
    <div class="report-row">
      <span class="report-label">Pagamentos aprovados</span>
      <span class="report-value"
        >{{ summary.paymentSuccess ?? 0 | number }}
        <ng-container *ngIf="summary.paymentSuccessBenefit">
          ({{ summary.paymentSuccessBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
    <div class="report-row report-row--highlight">
      <span class="report-label">Taxa de aprovação</span>
      <span class="report-value report-value--approval"
        >{{ approvalRate | number: '1.2-2' }}%</span
      >
    </div>
  </section>

  <section class="report-section">
    <div class="report-section-header">
      <h4>Falhas</h4>
    </div>
    <div
      class="report-row"
      [class.report-row--critical]="(summary.failureActivation ?? 0) > 0"
    >
      <span class="report-label">
        <i
          class="pi pi-exclamation-triangle"
          *ngIf="(summary.failureActivation ?? 0) > 0"
        ></i>
        Falha na Ativação
      </span>
      <span class="report-value"
        >{{ summary.failureActivation ?? 0 | number }}
        <ng-container *ngIf="summary.failureActivationBenefit">
          ({{ summary.failureActivationBenefit | number }} com benefício)
        </ng-container></span
      >
    </div>
    <div
      class="report-row"
      [class.report-row--critical]="(summary.failureEdition ?? 0) > 0"
    >
      <span class="report-label">
        <i
          class="pi pi-exclamation-triangle"
          *ngIf="(summary.failureEdition ?? 0) > 0"
        ></i>
        Falha na Criação de Edição
      </span>
      <span class="report-value"
        >{{ summary.failureEdition ?? 0 | number }}
        <ng-container *ngIf="summary.failureEditionBenefit">
          ({{ summary.failureEditionBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
    <div class="report-row">
      <span class="report-label">Falha no Pagamento</span>
      <span class="report-value"
        >{{ summary.failurePayment ?? 0 | number }}
        <ng-container *ngIf="summary.failurePaymentBenefit">
          ({{ summary.failurePaymentBenefit | number }} com benefício)
        </ng-container></span
      >
    </div>
    <div class="report-row">
      <span class="report-label">Falha na Validação</span>
      <span class="report-value"
        >{{ summary.failureValidation ?? 0 | number }}
        <ng-container *ngIf="summary.failureValidationBenefit">
          ({{ summary.failureValidationBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
  </section>

  <section class="report-section">
    <h4>Aguardando</h4>
    <div class="report-row">
      <span class="report-label">Aguardando Ativação</span>
      <span class="report-value"
        >{{ summary.waitingActivation ?? 0 | number }}
        <ng-container *ngIf="summary.waitingActivationBenefit">
          ({{ summary.waitingActivationBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
    <div class="report-row">
      <span class="report-label">Aguardando Criação de Edição</span>
      <span class="report-value"
        >{{ summary.waitingEdition ?? 0 | number }}
        <ng-container *ngIf="summary.waitingEditionBenefit">
          ({{ summary.waitingEditionBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
    <div class="report-row">
      <span class="report-label">Aguardando Pagamento</span>
      <span class="report-value"
        >{{
          (summary.waitingPayment ?? 0) + (summary.pendingPayment ?? 0) | number
        }}
        <ng-container *ngIf="summary.pendingPayment"
          >({{ summary.pendingPayment | number }} em andamento)</ng-container
        ></span
      >
    </div>
    <div class="report-row">
      <span class="report-label">Aguardando Validação</span>
      <span class="report-value">
        {{ summary.waitingValidation ?? 0 | number }}
        <ng-container *ngIf="summary.waitingValidationBenefit">
          ({{ summary.waitingValidationBenefit | number }} com benefício)
        </ng-container>
      </span>
    </div>
  </section>
</div>

<div>
  <a type="button" class="data-link" (click)="openErrorReportModal()">
    Ver detalhes de erros e pagamentos
  </a>
</div>

<div class="report-pubsub-link">
  <p style="margin-top: 2rem; font-size: 1rem; color: #444">
    Para detalhes das mensagens processadas em tempo real, consulte o
    <a
      href="https://console.cloud.google.com/monitoring?referrer=search&project=b4a-prj-shared-queues"
      target="_blank"
      rel="noopener noreferrer"
      style="color: #1976d2; text-decoration: underline"
    >
      Painel do Pub/Sub no Google Cloud Console </a
    >.
  </p>
</div>
